import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Services';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $getByUseServiceType = ActionCreator.Async(
  MODULE,
  'GetByUseServiceType',
  () => {
    return async (dispatch) => {
      dispatch($processing($getByUseServiceType.OPERATION));

      return await Rest.GET(`${API_URL}/tms/service/use`)
        .then((response) => {
          dispatch($getByUseServiceType.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($getByUseServiceType.OPERATION)));
    };
  }
);

export const $get = ActionCreator.Async(MODULE, 'Get', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tms/service`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/service/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $createType = ActionCreator.Async(
  MODULE,
  'Create.Type',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/service/type`, payload)
        .then((response) => {
          dispatch($createType.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $getType = ActionCreator.Async(MODULE, 'Get.Type', (payload) => {
  return async (dispatch) => {
    dispatch($processing($getType.OPERATION));

    return await Rest.GET(`${API_URL}/tms/service/type`, payload)
      .then((response) => {
        dispatch($getType.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getType.OPERATION)));
  };
});

export const $showType = ActionCreator.Async(MODULE, 'Show.Type', (id) => {
  return async (dispatch) => {
    dispatch($processing($showType.OPERATION));

    return await Rest.GET(`${API_URL}/tms/service/type/${id}`)
      .then((response) => {
        dispatch($showType.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($showType.OPERATION)));
  };
});

export const $updateType = ActionCreator.Async(
  MODULE,
  'Update.Type',
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/tms/service/type/${id}`, payload)
        .then((response) => {
          dispatch($updateType.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $deleteType = ActionCreator.Async(MODULE, 'Delete.Type', (id) => {
  return async (dispatch) => {
    dispatch($processing($deleteType.OPERATION));

    return await Rest.DELETE(`${API_URL}/tms/service/type/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($deleteType.OPERATION)));
  };
});

export const $download = ActionCreator.Async(
  MODULE,
  'Get.Template',
  (payload) => {
    return async (dispatch) => {
      dispatch($processing($download.OPERATION));

      return await Rest.GET(
        `${API_URL}/public/template/service/type
`,
        payload
      )
        .then((response) => {
          dispatch($download.success({ response: response?.data }));
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($download.OPERATION)));
    };
  }
);

export const $createBulkType = ActionCreator.Async(
  MODULE,
  'Create.Type.Bulk',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.POST(`${API_URL}/tms/service/type/bulk`, payload)
        .then((response) => {
          dispatch($createBulkType.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
